import { ChalkLink } from "@/components/interactive/ChalkLink";
import { Routes } from "@/utils/routes";
import type { FC } from "react";

export const IndividualSignupConsentNotice: FC<{ className?: string }> = ({ className }) => (
  <p className={className}>
    By continuing, you agree to Chalk's{" "}
    <ChalkLink href={Routes.legal.termsOfUse} openInNewTab>
      Terms of Use
    </ChalkLink>{" "}
    and acknowledge the{" "}
    <ChalkLink href={Routes.legal.privacy} openInNewTab>
      Privacy Policy
    </ChalkLink>
    .
  </p>
);
